import './libraries/slimmageSettings';
import './libraries/slimmage';
import './libraries/smoothscroll';

import 'lity';

// App
import App from './app';
import PolyfillController from './controllers/polyfill';

// Controllers
import HeaderController from './controllers/header';
import RibbonController from './controllers/ribbon';
import MediaController from './controllers/media';
// import AVGController from './controllers/avg';
import ConsentController from '@humandigital-agency/consent-controller';
import HeaderSearchController from './controllers/search/headerSearch';
import AccordeonController from './controllers/accordeon/controller';
import ResponsiveTableController from './controllers/responsiveTable';
import LocationsMapController from './controllers/locationsMap';
import FilterableOverviewController from './controllers/filterableOverview';
import SliderController from './controllers/slider';
import FormController from './controllers/form';

(async () => {
    document.querySelector('html').classList.remove('no-js');

    const polyfills = new PolyfillController();
    await polyfills.init();

    try {
        const app = new App();
        app.resizeThrottle = 10;
        app.scrollThrottle = 100;
        window.app = app;
    
        app.polyfillController = polyfills;
    
        // app.AVGController = new AVGController();
        app.ConsentController = new ConsentController();
        app.headerController = new HeaderController();
        app.ribbonController = new RibbonController();

        app.headerSearchController = new HeaderSearchController();
        app.mediaController = new MediaController();
        app.accordeonController = new AccordeonController();
        app.responsiveTableController = new ResponsiveTableController();

        app.locationsMapController = new LocationsMapController();
        app.filterableOverviewController = new FilterableOverviewController();
        app.sliderController = new SliderController();

        app.formController = new FormController();

        await app.init();
    } catch(e) {
        console.error(`Something went wrong initializing the app`);
        throw e;
    };

    console.log(`App initialized`);

    setTimeout(() => document.documentElement.classList.remove('preventAnimations'), 400);

})();